








































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AccountActionList} from '@/@types/LibraryComponent';
import { ConcernAccountList } from '@/@types/Member.ts';
import HumanResourceCard from '@/components/humanResourceSearch/HumanResourceCard.vue';
// import HumanResourceList from '@/components/member/memberCommon/HumanResourceList.vue';

@Component({
  components: {
    HumanResourceCard,
    // HumanResourceList,
  },
})
export default class HumanResourceSearchBase extends Vue {
  private isCard: boolean = true;
  private isList: boolean = false;
  private contents = [18, 60];
  private test = false;
  private sheet = false;
  private filterSelectedContents = [];
  private accountActionList: Array<AccountActionList> = [
    {
      icon: 'mdi-hand-heart',
      color: 'indigo',
      notDisabled: true,
      title: 'スカウト',
      message: 'スカウトを送信します',
      clickedText: 'スカウト送信済み',
    },
    {
      icon: 'mdi-laptop-chromebook',
      color: 'cyan darken-1',
      notDisabled: true,
      title: 'web面談オファー',
      message: 'web面談オファーして検討する',
      clickedText: 'web面談オファー送信済み',
    },
    {
      icon: 'mdi-heart',
      color: 'red lighten-3',
      notDisabled: true,
      title: '気になる',
      message: '気になるを送信します',
      clickedText: '気になる送信済み',
    },
  ];

  private concernAccountList = [
    {
      accountName: 'セオリー太郎',
      age: '24',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommended_flag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎',
      age: '24',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommended_flag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎',
      age: '24',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommended_flag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎',
      age: '24',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommended_flag: false,
      deleteFlag: false,
    },
  ];
  private filterContentList = [
    {
      title: '職種',
      contents: [
        'エンジニア',
        'フロントエンドエンジニア',
        'バックエンドエンジニア',
        'インフラエンジニア',
        'データサイエンティスト',
        'iOS/Androidアプリエンジニア',
        'プロジェクトリーダー',
        'プロジェクトマネージャー',
        'デザイナー',
        'マーケティング',
        'ライター',
        'セールス',
        'コーポレートスタッフ',
        'その他',
      ],
    },
    {
      title: '地域',
      contents: [
        '北海道・東北',
        '関東',
        '北陸・甲信越',
        '東海',
        '近畿',
        '中国・四国',
        '九州・沖縄',
        '海外',
      ],
    },
    {
      title: '働き方',
      contents: ['リモート', '出社', 'どちらでも可'],
    },
    {
      title: '年齢',
      contents: [18, 60],
    },
    {
      title: '最終ログイン',
      contents: ['一日以内', '一週間以内', '一カ月以内'],
    },
    {
      title: '特徴',
      contents: ['リモート希望', '★5の評価あり', '10プロジェクト以上経験'],
    },
    {
      title: '予定稼働時間',
      contents: [1, 168],
    },
  ];
  private isOpenSearchBox: boolean = false;
  private programmingLanguageSearchList = [];
  private sortItems: Array<string> = [
    'おすすめ順',
    '単価順',
    '評価順',
    'ログイン順',
  ];

  private viewIconColor(isView: boolean) {
    if (isView) {
      return '#4384f3';
    } else {
      return 'grey lighten-1';
    }
  }

  private DeleteFilterContent(content: string) {
    const index = this.filterSelectedContents.findIndex(
      (v: string) => v === content
    );
    const deleteFilterContent = this.filterSelectedContents.splice(index, 1);
  }
}
